'use strict';

var Reflux   = require('reflux'),
    Promise  = require('bluebird'),
    defaults = require('superagent-defaults'),
    request  = require('superagent-promise');

var request = defaults(request);

request.set('X-Requested-With', 'XMLHttpRequest')
       .type('application/json')
       .accept('application/json');

var TagSearchActions = Reflux.createActions({

    addCustomTag: {},
    tagTextChange: {},
    searchTags: { asyncResult: true, children: ['progressed'] },
    searchLocations: { asyncResult: true, children: ['progressed'] },
    searchSkills: {},
    searchAcademicPrograms: {},
    searchEvents: {},

});

TagSearchActions.searchTags.listen(function (tagId, searchQuery) {
    this.promise(request
        .get('https://hackerapi.com/v1/search/' + tagId)
        .query({
            q: searchQuery
        })
        .end()
    );
});

TagSearchActions.searchLocations.listen(function (tagId, searchQuery) {
    this.promise(request
        .get('https://maps.googleapis.com/maps/api/place/autocomplete/json?key=AIzaSyA52Y7-UG3x2wTB2QwSU9OAAjimvW3JJoM')
        .query({
            input: searchQuery
        })
        .end()
    );
});



module.exports = TagSearchActions;



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/actions/tag-actions.js
 ** module id = 238
 ** module chunks = 0 1 6 9
 **/